var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "4" } },
        [
          _c(
            "v-switch",
            _vm._b(
              {
                attrs: {
                  label: _vm.label,
                  hint: _vm.hint,
                  "persistent-hint": _vm.hint ? true : false,
                },
                on: { change: _vm.change },
                model: {
                  value: _vm.computedValue.active,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "active", $$v)
                  },
                  expression: "computedValue.active",
                },
              },
              "v-switch",
              _vm.$attrs,
              false
            )
          ),
        ],
        1
      ),
      _c(
        "v-expand-transition",
        [
          _vm.value.active
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "8" } },
                [
                  _vm._t("default", null, {
                    disabled: !_vm.value.active,
                    param: _vm.value.param,
                    errors: _vm.$utils.getIfExists(_vm.errorMessages, [
                      "param",
                    ]),
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.hideBelowArea
        ? _c(
            "v-expand-transition",
            [
              _vm.value.active
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        [
                          _vm._t("below", null, {
                            disabled: !_vm.value.active,
                            param: _vm.value.param,
                            errors: _vm.$utils.getIfExists(_vm.errorMessages, [
                              "param",
                            ]),
                          }),
                        ],
                        2
                      ),
                      !_vm.hideDivider ? _c("v-divider") : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }